<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-navbar></layout-navbar>
    <!-- Page Wrapper -->
    <div class="page-wrapper">

      <!-- Page Content -->
      <div class="content container-fluid">
        <div class="crms-title row bg-white">
          <div class="col p-0">
            <h3 class="page-title m-0">
              <span class="page-title-icon bg-gradient-primary text-white mr-2">
                <i class="feather-database"></i>
              </span></h3>
          </div>
          <div class="col text-right">
            <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
              <li class="breadcrumb-item"><router-link to="/index">AV Fragebogen Bearbeiten</router-link></li>
              <li class="breadcrumb-item active">{{customer_name}}</li>
            </ul>
          </div>
        </div>
        <div id="surveyCreatorContainer" class="survey-edit"></div>
      </div>
      <div class="sticky-wrapper" v-show="surveyReady">
        <div class="sticky-save-button"><button type="button" class="btn btn-success" @click="saveSurvey">Speichern</button></div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as SurveyCreator from "survey-creator-knockout";
  import "survey-creator-core/survey-creator-core.i18n"
  import {localization} from "survey-creator-core"
  localization.currentLocale = 'de'

  import * as Survey from "survey-core";
  import * as widgets from "surveyjs-widgets";
  import { init as customWidget } from "@/components/survey/customwidget";

  import "survey-core/defaultV2.css";
  import "survey-creator-core/survey-creator-core.css";
  import service from '@/utils/request'


  // widgets.icheck(Survey);
  widgets.select2(Survey);
  widgets.inputmask(Survey);
  widgets.jquerybarrating(Survey);
  widgets.jqueryuidatepicker(Survey);
  widgets.nouislider(Survey);
  widgets.select2tagbox(Survey);
  widgets.sortablejs(Survey);
  widgets.ckeditor(Survey);
  widgets.autocomplete(Survey);
  widgets.bootstrapslider(Survey);
  customWidget(Survey);

export default {
  name: 'TomsEdit',
  data() {
    return {
      surveyJSON: '',
      surveyCreator: null,
      surveyReady: false,
    }
  },
  created() {
    this.getSurveyBody()
  },
  methods: {
    saveSurvey: function() {
      this.modifySurvey(JSON.parse(this.surveyCreator.text))
    },
    modifySurvey: function(e) {
      service.request({
        url: 'survey/v1/survey/update/1/',
        method: 'PUT',
        data: { 'body': e }
      }).then((response) => {
        this.$vToastify.success('Fragebogen ist erfolgreich gespeichert!')
      }).catch((error) => this.$vToastify.error(`Speicherung ist fehlgeschlagen! Fehler: ${error}`))
    },
    getSurveyBody: async function() {
      const that = this
      service.request({
        url: 'survey/v1/survey/1/',
        method: 'GET',
        responseType: 'json'
      }).then(function(response) {
        that.surveyJSON = JSON.stringify(response.data.body)
        // const model = new SurveyVue.Model(that.surveyJSON)
        // model.onCompleting.add(
        //   function(sender, options) {
        //     if (!that.surveyConfirmed) {
        //       options.allowComplete = that.completeOption
        //       that.resultBody = JSON.stringify(sender.data)
        //       that.organizeResult(JSON.stringify(sender.data))
        //       that.dialogVisible = true
        //     }
        //   }
        // )
        const options = { showLogicTab: true, haveCommercialLicense: true }
        that.surveyCreator = new SurveyCreator.SurveyCreator(options)
        that.surveyCreator.saveSurveyFunc = function() {
          that.modifySurvey(JSON.parse(that.surveyCreator.text))
        }
        that.surveyCreator.text = that.surveyJSON
        that.surveyCreator.onTestSurveyCreated.add((sender, options) => {
          options.survey.onTextMarkdown.add((sender, options) => {
            console.log(sender)
            console.log(options)
            if (options.name === 'description') options.html = options.text
            if (options.name === 'text' && options.text.includes('Ja')) options.html = `<div class="sd-element-yes">${options.text}</div>`
            if (options.name === 'text' && options.text.includes('Nein')) options.html = `<div class="sd-element-no">${options.text}</div>`
          })
        })
        that.surveyCreator.render("surveyCreatorContainer")
        that.surveyReady = true
      }).catch(function(err) {
        console.log(err)
      })
    }
  }
}
</script>

<style>
@import '../../assets/bootstrap/css/bootstrap.min.css';
#surveyCreatorContainer {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
}

div.sticky-wrapper {
  float: right;
}

div.sticky-save-button {
  position: fixed;
  right: 500px;
  bottom: 100px;
}

.sd-body .sd-body__page {
  margin-left: auto!important;
  margin-right: auto!important;
  max-width: fit-content!important;
}
.sd-element .sd-element-yes:hover {
  background-color: rgba(0,255,0,0.4);
}
.sd-element .sd-element-no:hover {
  background-color: rgba(255,0,0,0.4);
}
</style>
